import MetricFrequencyModel from './metric-frequency-model'
import NewFrequencyView from './metric-frequency-new'
import AncestorStep from '../common/ancestor-step'
import ReportFilterUtil from '../common/report-filter-util'
import ScorecardReportModel from 'scoreboard/reports/scorecard-report/scorecard-report-model'

var MetricFrequencyPath = {
	icon: 'calendar',
	key: 'report.metricUpdateFrequencyReport.title',
	steps: [AncestorStep, {
		titleCode: 'report.metricUpdateFrequencyReport.title',
		view: NewFrequencyView,
		validate: function(attrs, opts) {
			let m = new ScorecardReportModel(attrs)
			let stacks = m.stacks().models
			//must have one column showing, at least one calendar and item selected
			return !stacks.length || !ReportFilterUtil.hasValues(attrs, 'nativeCalendarIds')
				|| !ReportFilterUtil.hasAncestorValues(attrs, 'scorecardNodeIds')
		}
	}],
	model: MetricFrequencyModel
}

export default MetricFrequencyPath

MetricFrequencyPath.__filename__ = 'reports/wizard/metric-frequency/metric-frequency-path.js'
